namespace SPA {
	export namespace Contacts {
		interface IStatusRowOptions extends Backbone.ViewOptions<SPA.ContactStatus> {
			mode?: 'contact' | 'object';
		}

		export class StatusRowView extends Backbone.View<SPA.ContactStatus>
		{
			private mode: 'contact' | 'object' | undefined;
			private contact: SPA.Contact | false | undefined;
			private object: SPA.Realtor.RealtorObjectModel | undefined;

			public constructor(options?: IStatusRowOptions) {
				super(options);
			}

			public preinitialize(options: IStatusRowOptions): void
			{
				options.tagName = 'div';
				options.className = 'contact-assign-row';

				options.events = {
					'click .link-object': this.onObjectLinkClick,
					'click .link-contact': this.onContactLinkClick
				};
			}

			public initialize(options: IStatusRowOptions = {}): void {
				if (options.mode)
				{
					this.mode = options.mode;
				}

				this.contact = app.getContactManager().getItem(this.model.ContactID);
				this.object = app.getObjectManager().getData(this.model.ObjectNumber);
				if (this.contact) {
					// Todo Event is triggered too many times
					this.listenTo(this.contact, 'change', this.render);
					// this.listenTo(this.contact, 'all', (...args) => console.log(this.contact, args));
				}
				if (this.object) {
					this.listenTo(this.object, 'change', this.render);
				}
				this.listenTo(this.model, 'change', this.render);
				this.listenTo(this.model, 'remove', this.onDeleteSuccess);
			}

			public render(): StatusRowView
			{
				this.$el.empty();
				if (!this.mode || this.mode === 'object') {
					this.renderObjectRow();
				} else {
					this.renderContactRow();
				}

				return this;
			}

			private renderObjectRow()
			{
				if (!this.model.ObjectNumber)
				{
					return;
				}
				const object = this.object as SPA.Realtor.RealtorObjectModel;
				// If the object is not in our object list, we have no access to its details
				if (!object) {
					this.$el.append(
						`<span>${this.model.ObjectNumber}</span>`,
						`<span>Zugriff auf Objekt-Details verweigert - gemeinsames Adressbuch, keine Objektberechtigungen</span>`
					);

					// return;
				} else {
					this.$el.append(`
						<a class="link link-object"><span>${this.model.ObjectNumber}</span></a>
						<span>${object.Address.display}</span>
						<span>
							<strong>${object.Data && object.Data.general ? accounting.formatMoney(object.Data.general.price.value) + ' €' : ' (ohne Preis)'}</strong>
						</span>
					`);
					// Only offer bidder deletion for now
					if (this.model.Name === 'bidder') {
						this.$el.append(app.getContactManager().buildDeleteButton(this.model, (done: boolean) => this.onDeleteSuccess(done)));
					}
				}
			}

			private renderContactRow()
			{
				// If the contact is not in our list, we have no access to its details
				if (!this.contact) {
					this.$el.append(
						`<span>Der Kontakt mit der ID #${this.model.ContactID} wurde nicht gefunden.</span>`
					);
				} else {
					this.$el.append(`
						<a class="link link-contact">
							${this.contact.Salutation ? SPA.types.Salutation[this.contact.Salutation as keyof typeof SPA.types.Salutation] : ''} ${this.contact.Title}
							${this.contact.Name} ${this.contact.Surname}
						</a>
						<span>${this.contact.Street} ${this.contact.HouseNumber}</span>
						<span>${this.contact.PostalCode} ${this.contact.City}</span>
						<span>${SPA.types.Address.State[this.contact.State as keyof typeof SPA.types.Address.State]}</span>
						<span> | </span>
						<span>${this.contact.Email}</span>
						<span>${this.contact.Phone}</span>
						<span>${this.contact.Mobile}</span>
					`);
					// Only offer bidder deletion for now
					if (this.model.Name === 'bidder') {
						this.$el.append(app.getContactManager().buildDeleteButton(this.model, (done: boolean) => this.onDeleteSuccess(done)));
					}
				}
			}

			private onDeleteSuccess(done: boolean)
			{
				super.stopListening();
				this.$el.fadeOut('slow', () => this.$el.remove());
			}

			private onObjectLinkClick(e: JQuery.Event)
			{
				const object = app.getObjectManager().getData(this.model.ObjectNumber);

				app.getGlobalTabControl().addTab(
					object.ObjectNumber,
					new SPA.Realtor.Page(object),
					true
				);
			}

			private onContactLinkClick()
			{
				const contact = app.getContactManager().getItem(this.model.ContactID);
				if (!contact)
				{
					return;
				}

				app.getGlobalTabControl().addTab(
					contact.Surname + ', ' + contact.Name + ' (' + contact.ContactID + ')',
					new SPA.Contacts.Detail(contact),
					true
				);
			}

		}
	}
}
